export const HKConstants: any = {
  // 素敵ネット共通で使用する定数
  CMN: {
    // 業務共通で使用する定数
    OPC: {
      // システム名
      SYSTEM_NAME: '素敵ネット',
      // サーバ名
      SERVER_NAME: '素敵ネットサーバ',
      // 施設予約画面のタイムライン表示開始時刻
      FACILITY_RESERVATION_TIMELINE_STARTING_POSITION: 8,
      // 同時入室番号の選択上限数
      MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS: 15,
      // 長谷工ID紹介画面URL
      ABOUT_HASEKO_ID_URL: 'https://www.haseko.co.jp/branchera/id/',
      // 住まいレージ紹介画面URL
      ABOUT_SMILE_URL: 'https://www.haseko.co.jp/branchera/smile/about.html',
      // パスワード再設定画面URL
      FLP_FORGET_PASSWORD_MAIL_URL: 'https://member.my-haseko.com/member_web/entrance/landing.html',
      // 住まいレージポイント画面URL
      FLP_SMILE_POINT_URL: 'https://haseko.flpjp.com/pointExchangeList',
      // 抽選終了後予約申込可能期間
      BIAS_PERIOD_FASTCOME_FASTSERVE: 1,
      // ファイルサイズの上限(Mega Byte)
      UPLOAD_FILE_LIMIT_MEGABYTES: 5,
      // 長谷工ID利用規約画面URL
      HASEKO_ID_USE_AGREEMENT_URL: 'https://member.my-haseko.com/member_web/idTerms/terms_hasekoid.html',
    },
    // システム共通で使用する定数
    SYC: {
      // トークン有効時間
      TOKEN_VALID_HOUR: 2,
      // 正常終了
      PROCESS_RESULT_SUCCESS: 0,
      // 警告あり終了
      PROCESS_RESULT_WARNING: 1,
      // 異常終了
      PROCESS_RESULT_ERROR: 2,
      // ファイルパスの最大表示長
      MAX_PATH_LENGTH_CAN_DISPLAYED: 60,
      // 省略を表す記号
      ELLIPSIS: '...',
      // マスク文字
      MASK: '●●●●●●',
      // セッションタイムアウトを示すHTTPステータス
      HTTP_STATUS_SESSION_TIMEOUT: 440,
      // FLP会員付帯属性情報更新APIの最大試行回数
      FLP_API_MEMBER_ATTR_UPDATE_MAX_ATTEMPTS: 4,
      // FLP会員付帯属性情報更新APIの適用終了日時の増加値
      FLP_API_MEMBER_ATTR_UPDATE_APPLY_END_DATE_INCREASE_SECONDS: 10,
      // 祝日取得APIの取得範囲（最小）
      MIN_HOLIDAY_DATE: '1900-01-01',
      // 祝日取得APIの取得範囲（最大）
      MAX_HOLIDAY_DATE: '9999-12-31',
    },
    // ユーティリティーで使用する定数
    UTL: {
    },
    // 災害時機能で使用する定数
    DIS: {
      // ファイルサイズ上限
      MAX_FILE_SIZE: 20,
    },
    // アクセス制御で利用する定数
    AUTH: {
      // 居住者ユーザ管理閲覧権限
      VIEW_RESIDENT_USER: 'VIEW-RESIDENT_USER',
      // メッセージ管理閲覧権限
      VIEW_MESSAGE: 'VIEW-MESSAGE',
      // マンション・管理組合情報管理閲覧権限
      VIEW_APART_ASSOC_INFO: 'VIEW-APART_ASSOC_INFO',
      // マンション情報管理閲覧権限
      VIEW_APART_INFO: 'VIEW-APART_INFO',
      // 管理組合情報管理閲覧権限
      VIEW_ASSOC_INFO: 'VIEW-ASSOC_INFO',
      // 代行予約閲覧権限
      VIEW_AGENT_RESERVE: 'VIEW-FACILITY_RESERVE',
      // 追加課金一覧閲覧権限
      VIEW_ADD_CHARGE: 'VIEW-ADD_CHARGE',
      // 予約一覧閲覧権限
      VIEW_RESERVE_LIST: 'VIEW-RESERVE_LIST',
      // 設備／施設設定閲覧権限
      VIEW_EQUIPMENT_FACILITY: 'VIEW-EQUIPMENT_FACILITY',
      // 施設説明閲覧権限
      VIEW_FACILITY_DESCRIPTION: 'VIEW-FACILITY_DESCRIPTION',
      // 施設全体説明閲覧権限
      VIEW_FACILITY_TOTAL_DESCRIPTION: 'VIEW-FACILITY_TOTAL_DESCRIPTION',
      // 施設休館設定閲覧権限
      VIEW_FACILITY_CLOSED_SETTING: 'VIEW-FACILITY_CLOSED_SETTING',
      // 施設予約管理閲覧権限
      VIEW_FACILITY_RESERVE: 'VIEW-FACILITY_RESERVE',
      // カレンダー管理閲覧権限
      VIEW_CALENDAR_MANAGEMENT: 'VIEW-CALENDAR_MANAGEMENT',
      // 生活便利帳管理閲覧権限
      VIEW_LIFE_NOTE_MANAGEMENT: 'VIEW-LIFE_NOTE_MANAGEMENT',
      // 情報交換掲示板管理閲覧権限
      VIEW_BOARD_MANAGEMENT: 'VIEW-BOARD_MANAGEMENT',
      // 物件管理閲覧権限
      VIEW_CONDOMINIUM: 'VIEW-CONDOMINIUM',
      // 管理者ユーザ管理閲覧権限
      VIEW_ADMIN_USER: 'VIEW-ADMIN_USER',
      // 物件グループ管理閲覧権限
      VIEW_CONDOMINIUM_GROUP: 'VIEW-CONDOMINIUM_GROUP',
      // 祝日管理閲覧権限
      VIEW_HOLIDAY: 'VIEW-HOLIDAY',
      // ログイン前メッセージ管理閲覧権限
      VIEW_LOGIN_BEFORE_MESSAGE: 'VIEW-LOGIN_BEFORE_MESSAGE',
      // 地域コード管理閲覧権限
      VIEW_AREA_CODE: 'VIEW-AREA_CODE',
      // メンテナンス設定閲覧権限
      VIEW_MAINTENANCE_SETTING: 'VIEW-MAINTENANCE_SETTING',
      // 理事会管理会議情報閲覧権限
      VIEW_ASSOC_DIRECTOR: 'VIEW-ASSOC_DIRECTOR',
      // 居住者ユーザ編集権限
      EDIT_RESIDENT_USER: 'EDIT-RESIDENT_USER',
      // メッセージ編集権限
      EDIT_MESSAGE: 'EDIT-MESSAGE',
      // マンション・管理組合情報編集権限
      EDIT_APART_ASSOC_INFO: 'EDIT-APART_ASSOC_INFO',
      // 代行予約編集権限
      EDIT_AGENT_RESERVE: 'EDIT-FACILITY_RESERVE',
      // 追加課金編集権限
      EDIT_ADD_CHARGE: 'EDIT-ADD_CHARGE',
      // 予約一覧編集権限
      EDIT_RESERVE_LIST: 'EDIT-RESERVE_LIST',
      // 設備／施設設定編集権限
      EDIT_EQUIPMENT_FACILITY: 'EDIT-EQUIPMENT_FACILITY',
      // 施設説明編集権限
      EDIT_FACILITY_DESCRIPTION: 'EDIT-FACILITY_DESCRIPTION',
      // 施設全体説明編集権限
      EDIT_FACILITY_TOTAL_DESCRIPTION: 'EDIT-FACILITY_TOTAL_DESCRIPTION',
      // 施設休館設定編集権限
      EDIT_FACILITY_CLOSED_SETTING: 'EDIT-FACILITY_CLOSED_SETTING',
      // 施設予約管理編集権限
      EDIT_FACILITY_RESERVE: 'EDIT-FACILITY_RESERVE',
      // カレンダー管理編集権限
      EDIT_CALENDAR_MANAGEMENT: 'EDIT-CALENDAR_MANAGEMENT',
      // 生活便利帳管理編集権限
      EDIT_LIFE_NOTE_MANAGEMENT: 'EDIT-LIFE_NOTE_MANAGEMENT',
      // 情報交換掲示板管理編集権限
      EDIT_BOARD_MANAGEMENT: 'EDIT-BOARD_MANAGEMENT',
      // 物件管理閲覧権限
      EDIT_CONDOMINIUM: 'EDIT-CONDOMINIUM',
      // 管理者ユーザ管理閲覧権限
      EDIT_ADMIN_USER: 'EDIT-ADMIN_USER',
      // 物件グループ管理閲覧権限
      EDIT_CONDOMINIUM_GROUP: 'EDIT-CONDOMINIUM_GROUP',
      // 祝日管理閲覧権限
      EDIT_HOLIDAY: 'EDIT-HOLIDAY',
      // ログイン前メッセージ管理閲覧権限
      EDIT_LOGIN_BEFORE_MESSAGE: 'EDIT-LOGIN_BEFORE_MESSAGE',
      // 理事会管理会議情報編集権限
      EDIT_ASSOC_DIRECTOR: 'EDIT-ASSOC_DIRECTOR',
      // 地域コード管理編集権限
      EDIT_AREA_CODE: 'EDIT-AREA_CODE',
      // メンテナンス設定編集権限
      EDIT_MAINTENANCE_SETTING: 'EDIT-MAINTENANCE_SETTING',
      // 居住者ユーザ出力権限
      OUTPUT_RESIDENT_USER: 'OUTPUT-RESIDENT_USER',
      // 予約一覧出力権限
      OUTPUT_RESERVE_LIST: 'OUTPUT-RESERVE_LIST',
      // 請求管理出力権限
      OUTPUT_BILLING_MANAGEMENT: 'OUTPUT-BILLING_MANAGEMENT',
      // 施設休館設定による施設予約キャンセル権限
      CANCEL_RESERVATION_FACILITY_CLOSED_SETTING: 'CANCEL_RESERVATION-FACILITY_CLOSED_SETTING',
      // 居住者ユーザ申請権限
      APPLY_RESIDENT_USER: 'APPLY-RESIDENT_USER',
      // 口座振替申請権限
      APPLY_ACCOUNT_TRANSFER: 'APPLY-ACCOUNT_TRANSFER',
      // 居住者ユーザ承認権限
      APPROVAL_RESIDENT_USER: 'APPROVAL-RESIDENT_USER',
      // 理事会管理出欠管理権限
      MANAGE_ATTENDANCE_ASSOC_DIRECTOR: 'MANAGE_ATTENDANCE-ASSOC_DIRECTOR',
      // 理事会管理コメント投稿権限
      POST_COMMENT_ASSOC_DIRECTOR: 'POST_COMMENT-ASSOC_DIRECTOR',
      // 申請受付権限
      RECEPTION_APPLICATION: 'RECEPTION-APPLICATION',
      // 申請承認権限
      APPROVAL_APPLICATION: 'APPROVAL-APPLICATION',
      // 申請承認操作代行権限
      APPROVAL_DELEGATE_APPLICATION: 'APPROVAL_DELEGATE-APPLICATION',
      // 申請印刷権限
      APPLICATION_PRINT_APPLICATION: 'APPLICATION_PRINT-APPLICATION',
      // 緊急時連絡表申請権限
      APPLY_CONTACT_ADDRESS_EMERGENCY: 'APPLY-CONTACT_ADDRESS_EMERGENCY',
      // 駐車場使用申込申請権限
      APPLY_PARKING_USE_APPLICATION: 'APPLY-PARKING_USE_APPLICATION',
      // 駐車場使用契約解約届申請権限
      APPLY_PARKING_WITHDRAWAL_APPLICATION: 'APPLY-PARKING_WITHDRAWAL_APPLICATION',
      // 自動車変更届申請権限
      APPLY_CAR_CHANGE_NOTIFICATION: 'APPLY-CAR_CHANGE_NOTIFICATION',
      // 自転車置場使用申請権限
      APPLY_BICYCLE_PARKING_USE_APPLICATION: 'APPLY-BICYCLE_PARKING_USE_APPLICATION',
      // 自転車置場使用許可解除届申請権限
      APPLY_BICYCLE_PARKING_WITHDRAWAL_APPLICATION: 'APPLY-BICYCLE_PARKING_WITHDRAWAL_APPLICATION',
      // バイク置場使用申込申請権限
      APPLY_BIKE_PARKING_USE_APPLICATION: 'APPLY-BIKE_PARKING_USE_APPLICATION',
      // バイク置場使用契約解約届申請権限
      APPLY_BIKE_PARKING_WITHDRAWAL_APPLICATION: 'APPLY-BIKE_PARKING_WITHDRAWAL_APPLICATION',
      // バイク変更届申請権限
      APPLY_BIKE_CHANGE_NOTIFICATION: 'APPLY-BIKE_CHANGE_NOTIFICATION',
      // ペット飼育申請申請権限
      APPLY_PET_BREEDING_APPLICATION: 'APPLY-PET_BREEDING_APPLICATION',
      // 健康診断報告書申請権限
      APPLY_PET_MEDICAL_CHECK_UP_REPORT: 'APPLY-PET_MEDICAL_CHECK_UP_REPORT',
      // ペット飼育中止届申請権限
      APPLY_PET_BREEDING_STOP: 'APPLY-PET_BREEDING_STOP',
      // 工事申請書申請権限
      APPLY_CONSTRUCTION_APPLICATION: 'APPLY-CONSTRUCTION_APPLICATION',
      // 工事完了届申請権限
      APPLY_CONSTRUCTION_COMPLETE_NOTIFICATION: 'APPLY-CONSTRUCTION_COMPLETE_NOTIFICATION',
      // 窓ガラスフィルム貼付申請申請権限
      APPLY_WINDOW_GLASS_FILM_PASTE_NOTIFICATION: 'APPLY-WINDOW_GLASS_FILM_PASTE_NOTIFICATION',
      // 長期不在届申請権限
      APPLY_LONG_TERM_ABSENCE_NOTIFICATION: 'APPLY-LONG_TERM_ABSENCE_NOTIFICATION',
      // 重量物搬入等届申請権限
      APPLY_HEAVY_LOADS_CARRY_IN_NOTIFICATION: 'APPLY-HEAVY_LOADS_CARRY_IN_NOTIFICATION',
      // 閲覧申請書申請権限
      APPLY_BROWSE_APPLICATION: 'APPLY-BROWSE_APPLICATION',
      // 申請参照権限
      VIEW_APPLICATION: 'VIEW-APPLICATION',
      // 管理組合参照権限
      VIEW_ASSOC: 'VIEW-ASSOC',
      // 管理組合編集権限
      EDIT_ASSOC: 'EDIT-ASSOC',
      // 管理事務報告参照権限
      VIEW_WORK_REPORT: 'VIEW-WORK_REPORT',
      // 管理事務報告編集権限
      EDIT_WORK_REPORT: 'EDIT-WORK_REPORT',
      // 組合員資格変更届発行権限
      ISSUE_OWNERSHIP_TRANSFER: 'ISSUE-OWNERSHIP_TRANSFER',
      // 組合員資格変更届参照権限
      VIEW_OWNERSHIP_TRANSFER: 'VIEW-OWNERSHIP_TRANSFER',
      // 組合員資格変更届参照（提出後のみ）権限
      VIEW_COMPLETE_ONLY_OWNERSHIP_TRANSFER: 'VIEW_COMPLETE_ONLY-OWNERSHIP_TRANSFER',
      // 組合員資格変更届印刷権限
      APPLICATION_PRINT_OWNERSHIP_TRANSFER: 'APPLICATION_PRINT-OWNERSHIP_TRANSFER',
      // 請求額参照権限
      VIEW_BILLING_AMOUNT: 'VIEW-BILLING_AMOUNT',
      // 領収書発行権限
      ISSUE_RECEIPT: 'ISSUE-RECEIPT',
      // 口座情報参照権限
      VIEW_ACCOUNT_INFORMATION: 'VIEW-ACCOUNT_INFORMATION',
      // 請求額利用制限設定権限
      RESTRICTION_SETTING_BILLING_AMOUNT: 'RESTRICTION_SETTING-BILLING_AMOUNT',
      // 領収書利用制限設定権限
      RESTRICTION_SETTING_RECEIPT: 'RESTRICTION_SETTING-RECEIPT',
      // 口座情報利用制限設定権限
      RESTRICTION_SETTING_ACCOUNT_INFORMATION: 'RESTRICTION_SETTING-ACCOUNT_INFORMATION',
      // 防災情報管理参照権限
      VIEW_DISASTER_PREVENTION: 'VIEW-DISASTER_PREVENTION',
      // 災害時情報共有管理参照権限
      VIEW_DISASTER_INFORMATION_SHARING: 'VIEW-DISASTER_INFORMATION_SHARING',
      // 災害時モード設定参照権限
      VIEW_DISASTER_MODE: 'VIEW-DISASTER_MODE',
      // 災害時モード設定CSV出力権限
      OUTPUT_DISASTER_MODE: 'OUTPUT-DISASTER_MODE',
      // 災害時モード設定編集権限
      EDIT_DISASTER_MODE: 'EDIT-DISASTER_MODE',
      // 防災情報管理編集権限
      EDIT_DISASTER_PREVENTION: 'EDIT-DISASTER_PREVENTION',
      // 災害時情報共有管理トピック登録権限
      REGISTER_TOPIC_DISASTER_INFORMATION_SHARING: 'REGISTER_TOPIC-DISASTER_INFORMATION_SHARING',
      // 災害時情報共有管理トピック削除権限
      DELETE_TOPIC_DISASTER_INFORMATION_SHARING: 'DELETE_TOPIC-DISASTER_INFORMATION_SHARING',
      // 災害時情報共有管理コメント投稿権限
      POST_COMMENT_DISASTER_INFORMATION_SHARING: 'POST_COMMENT-DISASTER_INFORMATION_SHARING',
      // 災害時情報共有管理コメント削除権限
      DELETE_COMMENT_DISASTER_INFORMATION_SHARING: 'DELETE_COMMENT-DISASTER_INFORMATION_SHARING',
      // 災害時情報共有管理CSV出力権限
      OUTPUT_DISASTER_INFORMATION_SHARING: 'OUTPUT-DISASTER_INFORMATION_SHARING',
      // 総会参照権限
      VIEW_GENERAL_MEETING: 'VIEW-GENERAL_MEETING',
      // 区分所有者確認編集権限
      EDIT_UNIT_OWNER_CONFIRMATION: 'EDIT-UNIT_OWNER_CONFIRMATION',
      // 区分所有者管理編集権限
      EDIT_UNIT_OWNER_MANAGEMENT: 'EDIT-UNIT_OWNER_MANAGEMENT',
    },
    // 施設予約機能で使用する定数
    FAC: {
      // 入退室管理で使用する定数
      ACM: {
        // RIKBシステムのAPIを送信する際に必要となるJWTのsubject値
        RIKB_API_JWT_SUBJECT: 'RikbExternalRelayService',
      },
    },
  },

  // 素敵ネット管理画面で使用する定数
  VMN: {
    // 物件管理機能で使用する定数
    CON: {
      // 施設予約先着対象期間の固定加算値
      BIAS_PERIOD_FIRST_ARRIVAL: 1,
    },
    // 物件グループ管理機能で使用する定数
    COG: {
      // 長谷工管理ホールディングスの物件グループID
      HASEKO_HOLDINGS_CONDOMINIUM_GROUP_ID: 1,
    },
    // 祝日管理機能で使用する定数
    HLD: {
    },
    // 管理者ユーザ管理機能で使用する定数
    ADM: {
      // 管理者ユーザ検索件数の上限値
      ADMINISTRATOR_USER_SEARCH_RESULTS_LIMIT: 100,
    },
    // 居住者ユーザ管理機能で使用する定数
    RES: {
      // 居住者ユーザ検索件数の上限値
      RESIDENCE_USER_SEARCH_RESULTS_LIMIT: 100,
      // 居住者ユーザCSV一括登録数の上限値
      RESIDENCE_USER_IMPORT_CSV_LINE_COUNT_LIMIT: 10000,
      // 居住者ユーザリスト出力の再読み込みまでの時間(ミリ秒)
      RESIDENT_USER_LIST_RELOAD_TIME: 10000,
      // ユーザ登録申請詳細画面のURL
      RESIDENT_USER_REGISTRATION_APPLY_DETAIL_URL: '/admin/condominiums/{condominiumCd}/applications/userRegistrationApply/{applyId}',
    },
    // 施設運営管理機能で使用する定数
    FAC: {
      // 施設名称の上限文字列長
      MAX_LENGTH_OF_FACILITY_NAME: 50,
      // 施設紹介文の上限文字列長(HTMLタグ含む)
      MAX_LENGTH_OF_FACILITY_INTRODUCTORY: 2000,
      // 施設の予約可能回数の上限値
      MAX_NUMBER_OF_RESERVATIONS: 99,
      // 施設の抽選申込数の上限値
      MAX_NUMBER_OF_LOTTERY_APPLICATION: 99,
      // 設備名称の上限文字列長
      MAX_LENGTH_OF_EQUIPMENT_NAME: 30,
      // 設備の説明文の上限文字列長
      MAX_LENGTH_OF_EQUIPMENT_DESCRIPTION: 100,
      // 施設予約の選択可能上限算出用の固定加算値(年)
      MAX_SELECTABLE_ADD_YEAR: 1,
      // 施設予約の選択可能上限の未来月
      MAX_SELECTABLE_MONTH: 12,
      // 施設予約の選択可能下限の過去年(システム稼働年)
      MIN_SELECTABLE_YEAR: 2020,
      // 施設オプション名の上限文字列長
      MAX_LENGTH_OF_FACILITY_OPTION_NAME: 30,
      // 施設オプションの単位名の上限文字列長
      MAX_LENGTH_OF_FACILITY_OPTION_UNIT_NAME: 10,
      // 施設の一覧表示順の上限値
      MAX_ORDER_OF_FACILITY_LIST_DISPLAY: 999,
      // 施設予約抽選優先度のデフォルト値
      DEFAULT_PRIORITY_VALUE_OF_RESERVATIONS: 100,
      // 施設予約抽選優先度の上限値
      MAX_PRIORITY_VALUE_OF_RESERVATIONS: 999,
      // 料金の上限値
      MAX_PRICE: 999999,
      // 予約受付開始月の上限値
      MAX_RESERVATION_ACCEPTANCE_START_MONTH: 12,
      // 予約受付開始日の上限値
      MAX_RESERVATION_ACCEPTANCE_START_DAY: 45,
      // 予約受付締切日の上限値
      MAX_RESERVATION_ACCEPTANCE_DEADLINE_DAY: 99,
      // キャンセル受付期限日の上限値
      MAX_CANCELLATION_DEADLINE_DAY: 99,
      // 最大予約時間の上限値
      MAX_RESERVATION_TIME_LIMIT_HOUR: 99,
      // 料金単位時間の上限値
      MAX_PRICE_UNIT_TIME_HOUR: 24,
      // 営業スケジュールの料金単位時間の上限値
      MAX_PRICE_UNIT_TIME_HOUR_OF_BUSINESS_SCHEDULE: 99,
      // 変動料金適用開始時間の上限値
      MAX_PRICE_APPLICATION_START_TIME: 99,
      // 施設オプションの一覧表示順の上限値
      MAX_ORDER_OF_FACILITY_OPTION_LIST_DISPLAY: 99,
      // 施設オプションの数量指定の上限値
      MAX_NUMBER_OF_OPTION_QUANTITY: 999,
      // 管理者予約のときに施設予約カードキーテーブルのカードキー番号に記録するダミー値
      ADMIN_RESERVATION_DUMMY_CARD_KEY_NUMBER: '9999',
      // 管理者予約のときに施設予約カードキーテーブルの棟コードに記録するダミー値
      ADMIN_RESERVATION_DUMMY_RIDGE_CD: '--',
      // 管理者予約のときに施設予約カードキーテーブルの棟名に記録するダミー値
      ADMIN_RESERVATION_DUMMY_RIDGE_NAME: 'DummyRidge',
      // 管理者予約のときに施設予約カードキーテーブルの部屋番号に記録するダミー値
      ADMIN_RESERVATION_DUMMY_ROOM_NUMBER: '----',
      // 管理者予約のときに施設予約カードキーテーブルの管理組合IDに記録するダミー値
      ADMIN_RESERVATION_DUMMY_ASSOC_ID: 0,
    },
    // 告知情報管理機能で使用する定数
    NTF: {
      // スケジュールカレンダーの選択可能上限算出用の固定加算値(年)
      MAX_SELECTABLE_ADD_YEAR: 2,
      // スケジュールカレンダーの選択可能上限の未来月
      MAX_SELECTABLE_MONTH: 3,
      // スケジュールカレンダーの選択可能下限の過去年(システム稼働年)
      MIN_SELECTABLE_YEAR: 2020,
      // 告知情報の一覧表示順の上限値
      MAX_ORDER_LIST_DISPLAY: 999,
      // 告知情報に掲載する資料の版数上限値
      MAX_NUMBER_OF_DOCUMENT_VERSION: 999,
      // 情報交換掲示板スレッドの保持期間（年）
      THREAD_RETENTION_YEAR: 2,
      // 長谷工ID規約同意ファイル名
      TERMS_FILENAME_HASEKO_PRIVACY: 'term_ha_20251112.html',
      // 個人情報保護方針規約同意ファイル名
      TERMS_FILENAME_PRIVACY_POLICY: 'term_pr_20220401.html',
      // 素敵ネット規約同意ファイル名
      TERMS_FILENAME_SUTEKI: 'kiyaku_st_20250515.html',
      // ブランシエラ規約同意ファイル名
      TERMS_FILENAME_BRANCIELA: 'term_br_20251112.html',
    },
    // システムサポート管理機能で使用する定数
    SYS: {
      // Cookieのアクセスキー_経由したログイン画面
      COOKIE_KEY_LOGIN_ROUTE: 'loginRoute',
      // 経由したログイン画面_管理会社向けログイン
      LOGIN_ROUTE_ADMIN: '1',
      // 経由したログイン画面_社員向けログイン（AD連携）
      LOGIN_ROUTE_AD: '2',
      // 経由したログイン画面_管理組合役員向けログイン
      LOGIN_ROUTE_ASSOC: '3',
    },
    // 理事会支援機能で使用する定数
    ASO: {
      // 会議資料のファイルサイズの上限(MB)
      MAX_MEETING_FILE_SIZE: 20,
      // 会議コメントへ登録するファイルのサイズの上限(MB)
      MAX_COMMENT_FILE_SIZE: 20,
      // 1会議に対するコメント数の上限件数
      MAX_COMMENT_COUNT: 1000,
      // 1コメントに対する返信コメント数の上限件数
      MAX_COMMENT_REPLY_COUNT: 1000,
    },
    // 災害時機能で使用する定数
    DIS: {
      // 防災情報一覧URL
      PREVENTION_LIST_URL: 'admin/condominiums/{condominiumCd}/disasters/preventions',
      // コメント詳細URL
      COMMENT_DETAILS_URL: 'admin/condominiums/{condominiumCd}/disasters/topics/{topicId}/comments/{commentId}',
      // モード設定状況一覧URL
      MODE_STATUSES_URL: 'admin/disasters/mode/statuses',
      // 災害時設定期間（月）
      SETTING_PERIOD_MONTH: 1,
    },
    // 総会支援機能で使用する定数
    GMT: {
      // 部屋に設定できる議決権数の上限値
      MAX_NUMBER_OF_VOTING_RIGHTS_COUNT_PER_ROOM: 99999,
      // 設定できる議案数の上限値
      MAX_NUMBER_OF_PROPOSAL_COUNT: 20,
      // 掲載資料のファイルサイズ(MB)の上限値
      MAX_FILE_SIZE: 50,
      // 掲載資料の合計ファイルサイズ(MB)の上限値
      MAX_TOTAL_FILE_SIZE: 100,
      // 掲載資料のファイル数の上限値
      MAX_TOTAL_FILE_COUNT: 10,
      // 投稿可能である質問件数の上限値
      MAX_NUMBER_OF_QUESTION_COUNT: 20,
    },
  },

  // 素敵ネット居住者用画面で使用する定数
  VRS: {
    // 物件管理機能で使用する定数
    CON: {
    },
    // 物件グループ管理機能で使用する定数
    COG: {
    },
    // 祝日管理機能で使用する定数
    HLD: {
    },
    // 管理者ユーザ管理機能で使用する定数
    ADM: {
    },
    // 居住者ユーザ管理機能で使用する定数
    RES: {
      // サブユーザの追加上限数
      SUB_USER_ADD_LIMIT: 4,
      // 素敵ネットTOPに表示するメッセージ一覧数
      MESSEAGE_LIST_NUMBER_FOR_TOP: 5,
      // 素敵ネットTOPに表示する予約確定一覧数
      RESERVE_LIST_NUMBER_FOR_TOP: 3,
      // 素敵ネットTOPに表示する申請履歴一覧数
      APPLY_HISTORY_LIST_NUMBER_FOR_TOP: 3,
      // サブユーザ登録用URL
      SUB_USER_REGIST_URL: 'resident/firstLoginPolicyAgree',
      // 素敵ネットユーザ登録用URL
      USER_REGIST_URL: 'resident/firstLoginUserInfoInput',
      // 素敵ネットユーザログインURL
      USER_LOGIN_URL: 'resident/login',
      // 素敵ネットユーザログイン手順URL
      USER_LOGIN_PROCEDURE_URL: 'resources/contents/manual/residentLoginProcedure.pdf',
      // 素敵ネットパスワード再設定URL
      USER_FORGOT_PASSWORD_URL: 'resident/passwordResetInput',
      // 素敵ネットメールアドレス変更再URL
      USER_CHANGE_MAILADDRESS_URL: 'resident/changeMailAddressComplete',
      // 初回ログイン長谷工IDパスワード確認画面URL
      USER_HASEKO_PASSWORD_CONFIRM_URL: 'resident/firstLoginHasekoIdPasswordConfirm',
      // 初回ログイン素敵ネットパスワード確認画面URL
      USER_SUTEKI_PASSWORD_CONFIRM_URL: 'resident/firstLoginSutekiPasswordConfirm',
      // 管理者ユーザログインURL
      ADMIN_USER_LOGIN_URL: 'admin/login',
      // 管理組合ユーザ向けログインURL
      ADMIN_USER_ASSOC_LOGIN_URL: 'admin/assoc/login',
    },
    // 施設運営管理機能で使用する定数
    FAC: {
      // 施設予約の選択可能下限算出用の固定減算値(月)
      MIN_SELECTABLE_SUB_MONTH: 2,
      // あなたの予約状況URL
      USER_RESERVATION_LIST_URL: 'residents/#/facilities/reservationlist',
    },
    // 告知情報管理機能で使用する定数
    NTF: {
      // カレンダー参照に表示する１日のイベント表示件数の上限値
      MAX_NUMBER_OF_EVENT_CALENDAR: 2,
      // 情報交換掲示板URL
      USER_BOARD_URL: 'resident/login?seniurl=/resident/bulletinBoardThread',
      // 情報訪韓掲示板スレッドの有効日数
      EXPIRATION_DATE: 547,
    },
    // コミュニケーションボード機能で使用する定数
    CMB: {
      // メッセージ参照画面に表示するメッセージ件数
      MESSEAGE_LIMIT_DISPLAY: 1,
      // メッセージ参照画面に表示するメッセージの検索開始位置の上限値
      MESSEAGE_LIMIT_OFFSET: 3,
      // 施設の予約状況画面に表示する施設件数
      MESSEAGE_LIMIT_FACILITY_LIMIT_DISPLAY: 5,
      // カレンダー参照に表示する１日のイベント表示件数の上限値
      MAX_NUMBER_OF_EVENT_CALENDAR: 3,
      // 誌面ダイジェストで表示する動画のパターン数
      JOURNAL_DIGEST_PATTERN_NUM: 6,
      // 誌面ダイジェストの切替曜日の調整値
      BASE_WEEKDAY_ADJUSTMENT: 3,
    },
    // 申請管理機能で使用する定数
    PCD: {
      // 緊急時連絡表の家族構成に追加できる上限値
      FAMILY_STRUCTURE_ADD_LIMIT: 10,
      // 閲覧申請の同行者に追加できる上限値
      BROWSE_ACCOMPANY_ADD_LIMIT: 2,
      // 申請関連の基礎となるURL
      APPLICATION_BASE_URL: 'resident/condominiums/{condominiumCd}/applications',
    },
    // システムサポート管理機能で使用する定数
    SYS: {
      // システムメンテナンス開始日時
      MAINTENANCE_START_DATETIME: '2022/01/01 00:00:00',
      // システムメンテナンス終了日時
      MAINTENANCE_END_DATETIME: '2022/01/02 23:59:59',
      // お問い合わせURL（マンション）
      CONTACT_WEB_URL_MANSION: 'https://reg34.smp.ne.jp/regist/is?SMPFORM=ncmf-ldtisf-f707ef886dcbb3a79b8c3685bb9b1182',
      // お問い合わせURL（素敵ネット）
      CONTACT_WEB_URL_SUTEKI: 'https://reg34.smp.ne.jp/regist/is?SMPFORM=ncmf-oekdm-9329195fea6c572ece6752134200aeb4',
      // お問い合わせフォーム（ブランシエラクラブ）
      CONTACT_WEB_URL_BRANCHERA: 'https://haseko-brc-form.spiral-site.com/contact',
      // ブランシエラクラブ公式サイト
      OFFICIAL_WEB_URL_BRANCHERA: 'https://www.haseko.co.jp/branchera/about.html',
      // お問い合わせURL
      CONTACT_WEB_URL: 'resident/contactus',
    },
    // 災害時機能で使用する定数
    DIS: {
      // 防災たすけあいトップURL
      PREVENTION_TOP_URL: 'resident/condominiums/{condominiumCd}/disasters/prevention/top',
      // 災害時トップの表示期間（年）
      PAST_TOPIC_BACK_YEAR: 3,
      // トピック詳細URL
      TOPIC_DETAILS_URL: 'resident/condominiums/{condominiumCd}/disasters/topics/{topicId}',
      // トピック一覧URL
      TOPICS_URL: 'resident/condominiums/{condominiumCd}/disasters/topics',
    },
  },

  // 素敵ネットゲスト用画面で使用する定数
  VGS: {
    // 組変で使用する定数
    OST: {
      // ゲストユーザによるinsert/update時に使用するユーザID
      GUEST_USER: 'GUEST',
      // 組合員資格変更届-新組合員の共有者に追加できる上限値
      SHARER_ADD_LIMIT: 3,
      // 認証コードの有効時間
      AUTH_CODE_VALID_ADD_TIME: 10,
    },
    // システムサポート管理機能で使用する定数
    SYS: {
      // ゲストユーザ用お問い合わせURL
      CONTACT_WEB_URL: 'guest/contactus',
    },
  },

  // 素敵ネットバッチで使用する定数
  BAT: {
    // 物件管理機能で使用する定数
    CON: {
    },
    // 物件グループ管理機能で使用する定数
    COG: {
    },
    // 祝日管理機能で使用する定数
    HLD: {
      // Holidays JP APIのURL
      HOLIDAYS_JP_API_URL: 'https://holidays-jp.github.io/api/v1/date.json',
    },
    // 管理者ユーザ管理機能で使用する定数
    ADM: {
    },
    // 居住者ユーザ管理機能で使用する定数
    RES: {
    },
    // 施設運営管理機能で使用する定数
    FAC: {
    },
    // 告知情報管理機能で使用する定数
    NTF: {
    },
    // システムサポート管理機能で使用する定数
    SYS: {
    },
    // 祝日管理機能で使用する定数
    DIS: {
      // 災害時モード終了通知期間（日）
      MODE_END_NOTICE_PERIOD_DAY: 7,
    },
  },

  // 素敵ネットAPIで使用する定数
  API: {
    // description of FAC
    FAC: {
      // 施設予約情報取得APIにて返却する施設予約上限
      MAX_NUMBER_OF_RESERVATION_INFO: 100,
    },
    // 個人情報をログ出力する際のマスク文字列
    RES: {
      // 個人情報をログ出力する際のマスク文字列
      MASK_DISPLAY_VALUE: '*** Masked ***',
    },
    // 入退室管理システム用API
    ACM: {
      // 施設予約情報取得APIにて返却する施設予約上限
      MAX_NUMBER_OF_RESERVATION_FOR_ACM: 10000,
    },
  },

}
